// extracted by mini-css-extract-plugin
module.exports = {"backgroundStyleDashboard":"Dashboard_backgroundStyleDashboard__1hGWI","TopBarApplication":"Dashboard_TopBarApplication__21kB8"};